import actionTypes from '../../actionTypes'
import initial from '../../initial'

const workspace = (state = initial.workspace, action) => {
  switch (action.type) {
  case actionTypes.SET_WORKSPACES:
    return { ...state, workspaces: action.payload }
  case actionTypes.SET_SELECTED_WORKSPACE:
    return { ...state, selectedWorkspace: action.payload }
  case actionTypes.SET_WS_ROLE:
    return { ...state, wsRole: action.payload }
  case actionTypes.SET_PROGRESS_DATA:
    return { ...state, progressData: action.payload }
  case actionTypes.SET_PROGRESS_DRAWERS:
    return { ...state, progressDrawers: action.payload }
  default:
    return state
  }
}

export default workspace
